import request from '@/utils/request'

import requestUrl from '@/utils/requestApi'

//更新个人基本信息
export function updateMemberInfo(data) {
    return request({
        url: requestUrl.updateMemberInfo,
        method: 'POST',
        data: data
    })
}

// 我的收藏
export function findPage(params) {
    return request({
        url: requestUrl.findPage,
        method: 'GET',
        params: params
    })
}

// 我的收藏--添加到购物车
// export function addCart(data) {
//   return request({
//     url: requestUrl.addCart,
//     method: 'POST',
//     data: data
//   })
// }
// 删除收藏商品
export function deleteProduc(id) {
    return request({
        url: requestUrl.deleteProduc + '?id=' + id,
        method: 'GET',
    })
}

// 通知设置
export function notic(params) {
    return request({
        url: requestUrl.notic + '?noticTel=' + params.phone + '&noticMail=' + params.mail,
        method: 'GET',
    })
}



// WEBPACK FOOTER //
// ./src/api/personal.js